// import React from "react";
// import {
//   Box,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   Avatar,
//   Chip,
//   Paper
// } from "@mui/material";
// import { motion } from "framer-motion";
// import dayjs from "dayjs";
// import { getData } from "../Webservice/Webservice";

// const paymentColors = {
//   paid: "success",
//   processing: "warning",
//   failed: "error"
// };

// const orderColors = {
//   placed: "info",
//   pending: "secondary",
//   cancelled: "error"
// };

// export default function RecentOrders() {
//   // 🔹 Sample Data
//   const recentOrders = [
//     {
//       _id: "690c780de704fef708bca394",
//       customerId: {
//         name: "Guru Karthick",
//         mobile: "+919876543210"
//       },
//       totalAmount: 392,
//       paymentStatus: "paid",
//       orderStatus: "placed",
//       createdAt: "2025-11-06T10:27:25.087Z",
//       orderNumber: "ORD-000447"
//     },
//     {
//       _id: "690c77a65ce6af18894061bf",
//       customerId: {
//         name: "Guru Karthick",
//         mobile: "+919876543210"
//       },
//       totalAmount: 392,
//       paymentStatus: "processing",
//       orderStatus: "pending",
//       createdAt: "2025-11-06T10:25:42.054Z",
//       orderNumber: "ORD-000445"
//     },
//     {
//       _id: "690c6a4d8a25fc1c61dfdc71",
//       customerId: {
//         name: "Guru Karthick ❤️",
//         mobile: "+918608224604"
//       },
//       totalAmount: 942,
//       paymentStatus: "processing",
//       orderStatus: "pending",
//       createdAt: "2025-11-06T09:28:45.458Z",
//       orderNumber: "ORD-000438"
//     },
//     {
//       _id: "690c713df287e8896ec7aa51",
//       customerId: {
//         name: "Guru Karthick",
//         mobile: "+919876543210"
//       },
//       totalAmount: 586,
//       paymentStatus: "paid",
//       orderStatus: "placed",
//       createdAt: "2025-11-06T09:58:21.573Z",
//       orderNumber: "ORD-000444"
//     },
//     {
//       _id: "6908aa1fa203ede79216836a",
//       customerId: {
//         name: "Guru Karthick ❤️",
//         mobile: "+918608224604"
//       },
//       totalAmount: 732,
//       paymentStatus: "processing",
//       orderStatus: "pending",
//       createdAt: "2025-11-03T13:11:59.879Z",
//       orderNumber: "ORD-000433"
//     }
//   ];

//   return (
//     <Paper
//       component={motion.div}
//       elevation={3}
//       sx={{
//         borderRadius: 4,
//         p: 3,
//         background: "linear-gradient(135deg, #f9fafb, #ffffff)",
//         mt: 3
//       }}
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.5 }}
//     >
//       {/* Header */}
//       <Box
//         sx={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           mb: 3
//         }}
//       >
//         <Typography
//           variant="h5"
//           sx={{
//             fontWeight: 700,
//             textAlign: "center",
//             color: "text.primary",
//             fontFamily: "Mulish, sans-serif",
//             mt: 4
//           }}
//         >
//           Recent Orders
//         </Typography>
//         <Typography variant="body2" sx={{ color: "text.secondary" }}>
//           Showing last {recentOrders.length} orders
//         </Typography>
//       </Box>

//       {/* Table */}
//       <Table>
//         <TableHead>
//           <TableRow sx={{ backgroundColor: "#f4f6f8" }}>
//             <TableCell sx={{ fontWeight: 600 }}>Order No.</TableCell>
//             <TableCell sx={{ fontWeight: 600 }}>Customer</TableCell>
//             <TableCell sx={{ fontWeight: 600 }}>Amount (₹)</TableCell>
//             <TableCell sx={{ fontWeight: 600 }}>Payment</TableCell>
//             <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
//             <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {recentOrders.map(order =>
//             <TableRow key={order._id}>
//               <TableCell sx={{ fontWeight: 600, color: "#000000ff" }}>
//                 {order.orderNumber}
//               </TableCell>

//               <TableCell>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                   <Box>
//                     <Typography
//                       sx={{ fontWeight: 500, color: "#111827", fontSize: 14 }}
//                     >
//                       {order.customerId.name}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </TableCell>

//               <TableCell sx={{ fontWeight: 600, color: "#16a34a" }}>
//                 ₹{order.totalAmount}
//               </TableCell>

//               <TableCell>
//                 <Chip
//                   label={order.paymentStatus}
//                   color={paymentColors[order.paymentStatus] || "default"}
//                   size="small"
//                   sx={{ textTransform: "capitalize" }}
//                 />
//               </TableCell>

//               <TableCell>
//                 <Chip
//                   label={order.orderStatus}
//                   color={orderColors[order.orderStatus] || "default"}
//                   size="small"
//                   sx={{ textTransform: "capitalize" }}
//                 />
//               </TableCell>

//               <TableCell sx={{ color: "text.secondary" }}>
//                 {dayjs(order.createdAt).format("DD MMM, YYYY")}
//               </TableCell>
//             </TableRow>
//           )}
//         </TableBody>
//       </Table>
//     </Paper>
//   );
// }

import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Avatar,
  Chip,
  Paper,
  CircularProgress,
  Alert
} from "@mui/material";
import { motion } from "framer-motion";
import dayjs from "dayjs";
import { getData } from "../Webservice/Webservice";

const paymentColors = {
  paid: "success",
  processing: "warning",
  failed: "error"
};

const orderColors = {
  placed: "info",
  pending: "secondary",
  cancelled: "error"
};

export default function RecentOrders() {
  const [recentOrdersData, setRecentOrdersData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRecentOrders = async () => {
      try {
        setLoading(true);
        setError(null);
        const tokenValue = sessionStorage.getItem("token");
        const token = tokenValue ? `Bearer ${tokenValue}` : "";
        const data = await getData("dashboard/recent-orders", null, token);

        if (data && data.success && data.recentOrders) {
          setRecentOrdersData(data);
        } else {
          throw new Error("Invalid recent orders response format");
        }
      } catch (err) {
        setError(err.message || "Failed to load recent orders");
      } finally {
        setLoading(false);
      }
    };

    fetchRecentOrders();
  }, []);

  // Show loading state
  if (loading) {
    return (
      <Paper
        component={motion.div}
        elevation={3}
        sx={{
          borderRadius: 4,
          p: 3,
          background: "linear-gradient(135deg, #f9fafb, #ffffff)",
          mt: 3,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 400
        }}
      >
        <CircularProgress />
      </Paper>
    );
  }

  // Show error state
  if (error) {
    return (
      <Paper
        component={motion.div}
        elevation={3}
        sx={{
          borderRadius: 4,
          p: 3,
          background: "linear-gradient(135deg, #f9fafb, #ffffff)",
          mt: 3
        }}
      >
        <Alert severity="error">
          {error}
        </Alert>
      </Paper>
    );
  }

  // Show data when available
  if (!recentOrdersData) {
    return null;
  }

  const orders = (recentOrdersData && recentOrdersData.recentOrders) || [];
  const totalCount = (recentOrdersData && recentOrdersData.totalCount) || 0;

  return (
    <Paper
      component={motion.div}
      elevation={3}
      sx={{
        borderRadius: 4,
        p: 3,
        background: "linear-gradient(135deg, #f9fafb, #ffffff)",
        mt: 3
      }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            textAlign: "center",
            color: "text.primary",
            fontFamily: "Mulish, sans-serif",
            mt: 4
          }}
        >
          Recent Orders
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          Showing last {orders.length} orders
        </Typography>
      </Box>

      {/* Table */}
      <Table>
        <TableHead>
          <TableRow sx={{ backgroundColor: "#f4f6f8" }}>
            <TableCell sx={{ fontWeight: 600 }}>Order No.</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Customer</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Amount (₹)</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Payment</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders.map(order =>
            <TableRow key={order._id || order.orderNumber}>
              <TableCell sx={{ fontWeight: 600, color: "#000000ff" }}>
                {order.orderNumber}
              </TableCell>

              <TableCell>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <Box>
                    <Typography
                      sx={{ fontWeight: 500, color: "#111827", fontSize: 14 }}
                    >
                      {order.customerId?.name || "-"}
                    </Typography>
                    <Typography
                      sx={{ fontSize: "12px", color: "text.secondary" }}
                    >
                      {order.customerId?.mobile || "-"}
                    </Typography>
                  </Box>
                </Box>
              </TableCell>

              <TableCell sx={{ fontWeight: 600, color: "#16a34a" }}>
                ₹{order.totalAmount ?? 0}
              </TableCell>

              <TableCell>
                {(() => {
                  const isCOD = order.paymentDetails?.mode?.toUpperCase() === 'COD';
                  const displayStatus = isCOD ? 'COD - Pending' : (order.paymentStatus || "-");
                  const color = isCOD ? paymentColors['pending'] : (paymentColors[order.paymentStatus] || "default");
                  return (
                    <Chip
                      label={displayStatus}
                      color={color}
                      size="small"
                      sx={{ textTransform: "capitalize" }}
                    />
                  );
                })()}
              </TableCell>

              <TableCell>
                <Chip
                  label={order.orderStatus || "-"}
                  color={orderColors[order.orderStatus] || "default"}
                  size="small"
                  sx={{ textTransform: "capitalize" }}
                />
              </TableCell>

              <TableCell sx={{ color: "text.secondary" }}>
                {order.createdAt ? dayjs(order.createdAt).format("DD MMM, YYYY") : "-"}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Paper>
  );
}
